"use client";

import { useSyncExternalStore } from "react";

function subscribeNoop() {
  return () => {};
}
function getMountedSnapshot() {
  return true;
}
function getServerSnapshot() {
  return false;
}

/** True once hydrated on the client — avoids a hydration mismatch for client-only UI. */
export function useMounted() {
  return useSyncExternalStore(subscribeNoop, getMountedSnapshot, getServerSnapshot);
}
